/*@ngInject*/
const AlertHandler = function ($rootScope, alertRegistrationRepository, localization, loadUserDetailsRepository, coreConstant, notificationPreferenceRepository, appTypeConfigurationModel, $injector) {
    let registeredChannels = [];
    let notificationName;
    let systemAnnouncementChannelList = [
        'allAgents',
        'allUws',
        'allSUs'
    ];
    let FORCE_LOGOUT_CHANNEL_STRING = 'forceLogout:';
    let MESSAGE_CHANNEL_STRING = 'message:';
    let GLOBAL_MESSAGE_CHANNEL_STRING = 'globalMessage';
    let CLIENT_CHANNEL_STRING = '';

    this.start = function (clientId) {
        function startAlertHandler(principalId) {
            if (clientId) {
                let forceLogoutChannel = FORCE_LOGOUT_CHANNEL_STRING + clientId,
                    simplePrincipalId = principalId,
                    channels = [],
                    globalMessageChannel = GLOBAL_MESSAGE_CHANNEL_STRING,
                    allChannel = appTypeConfigurationModel.getAllChannel(),
                    clientIdChannel = CLIENT_CHANNEL_STRING,
                    sessionMessageChannel = MESSAGE_CHANNEL_STRING + clientId,
                    channelsNotRegistered,
                    channelsToBeRemoved;

                if (simplePrincipalId) {
                    let seperatorIndex = simplePrincipalId.lastIndexOf(':');
                    if (seperatorIndex > -1) {
                        simplePrincipalId = simplePrincipalId.substring(seperatorIndex + 1);
                    }
                }
                let messageChannel = MESSAGE_CHANNEL_STRING + simplePrincipalId;

                channels.push(forceLogoutChannel);
                channels.push(messageChannel);
                channels.push(globalMessageChannel);
                channels.push(allChannel);
                channels.push(clientIdChannel);
                channels.push(sessionMessageChannel);

                channelsNotRegistered = _.difference(channels, registeredChannels);
                channelsToBeRemoved = _.difference(registeredChannels, channels);

                if (!_.isNil(channelsToBeRemoved) && channelsToBeRemoved.length > 0) {
                    alertRegistrationRepository.performRegistration('', true).then(function () {
                        alertRegistrationRepository.performRegistration(channels, false).then(function () {
                            registeredChannels = channels;
                        });
                    });
                } else if (!_.isNil(channelsNotRegistered) && channelsNotRegistered.length > 0) {
                    alertRegistrationRepository.performRegistration(channelsNotRegistered, false).then(function () {
                        registeredChannels = channels;
                    });
                }
            }
        }

        loadUserDetailsRepository.loadUserDetails().then((userProfile) => {
            let userType = userProfile.userType;
            appTypeConfigurationModel.setUserType(userType);
            startAlertHandler(userProfile.principalId);
        });
    };

    this.stop = function () {
        if (registeredChannels && registeredChannels.length > 0) {
            registeredChannels = [];
            alertRegistrationRepository.performRegistration('', true).then(onSuccess, onError);
        }
    };

    this.clearRegisteredChannels = function () {
        registeredChannels = [];
    };

    this.showAlert = function (alert) {
        if (_.includes(systemAnnouncementChannelList, alert.channel)) {
            localization.getTranslationByKey('systemAnnouncement.title').then(function (translation) {
                showModalNotificationMessage(translation, alert.message);
            });
        } else if (_.startsWith(alert.channel, FORCE_LOGOUT_CHANNEL_STRING)) {
            localization.getTranslationByKey('forceLogout.title').then(function (translation) {
                showModalNotificationMessage(translation, alert.message);
                $injector.get('coreMediator').logout();
            });
        } else {
            notificationName = alert.notification;
            if (isAcordUpload(alert)) {
                processNotificationPreference(JSON.parse(alert.notificationValue), alert.variables.submissionId);
            } else {
                if (alert.notificationValue) {
                    processNotificationPreference(JSON.parse(alert.notificationValue), -1);
                } else if(!_.isNil(alert.customButtonType) && alert.customButtonType === 'customAlert') {
                    showCustomButtonNotification(alert);
                } else if (alert.notification) {
                    notificationPreferenceRepository.getNotificationPopupTemplate(alert.notification, alert.variables).then(processNotificationPreference);
                } else {
                    processNotificationPreference(alert, -1);
                }
            }
        }
    };

    function showCustomButtonNotification(alert) {
        const options = {
            title : alert.title,
            summary : alert.message,
            customButtonType : alert.customButtonType,
            customButtons : alert.customButtons,
            notificationName : notificationName,
            contextParameters : alert.variables.contextParameters
        };
        $rootScope.$broadcast(coreConstant.event.SHOW_CUSTOM_ALERT_MODAL_NOTIFICATION, options);
    }

    function isAcordUpload(alert) {
        return alert.notification && (alert.notification === 'acordUploadCompleteReviewEffectiveDate' || alert.notification === 'acordUploadComplete');
    }

    function processNotificationPreference(notification, actionId) {
        localization.getTranslationByKey('alert.genericAlertTitle').then(function (genericAlertTitle) {
            if (!isNotificationHidden(notification) && (_.isNil(notification.id) || notification.enabled)) {
                const title = notification.title ? notification.title : genericAlertTitle;
                let body = notification.body || notification.message;
                if (body) {
                    body = body.replace(/\\n/g, '\n');
                    showNotificationMessage(title, body, actionId, notificationName);
                }
            }
            notificationName = '';
        });
    }

    function isNotificationHidden(notification) {
        return notification.excludeConsole && (
            (notification.excludeConsole === 'Producer' && appTypeConfigurationModel.isAgentConsole()) ||
            (notification.excludeConsole === 'Underwriter' && appTypeConfigurationModel.isUnderwriterWorkstation())
        );
    }

    function showModalNotificationMessage(notificationTitle, notificationMessage) {
        localization.getTranslations().then(function (translations) {
            $rootScope.$broadcast(coreConstant.event.SHOW_MODAL_NOTIFICATION, {
                title: notificationTitle,
                summary: notificationMessage,
                cancelButtonLabel: _.get(translations, 'alert.okButtonLabel')
            });
        });
    }

    function showNotificationMessage(notificationTitle, notificationMessage, actionId, notificationName) {
        localization.getTranslations().then(function (translations) {
            const options = {};
            options.title = notificationTitle;
            options.summary = notificationMessage;
            options.confirmActionButtonLabel = actionId > 0 ? _.get(translations, 'alert.confirmActionButtonLabel') : _.get(translations, 'alert.okButtonLabel');
            options.notificationName = notificationName;

            if (actionId > 0) {
                options.cancelButtonLabel = _.get(translations, 'alert.cancelActionButtonLabel');
            }

            if (!_.isNil(notificationName) && (notificationName !== 'acordUploadCompleteReviewEffectiveDate' && notificationName !== 'acordUploadComplete')) {
                $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, notificationMessage);
            } else {
                $rootScope.$broadcast(coreConstant.event.ACORD_UPLOAD_NOTIFICATION, options, actionId);
            }
        });
    }

    function replaceMessageVariables(message, variables) {
        _.forEach(variables, function (property) {
            let messageArray = message.split('{' + property + '}');
            message = messageArray.join(variables[property]);
        });
        return message;
    }
};

angular.module('umCore')
    .service('alertHandler', AlertHandler);
